import { gql } from '@apollo/client'

export const AUTHENTICATE_USER_WITH_APPLE = gql`
  mutation authenticateUserWithApple($input: AuthenticateAppleUserInput!) {
    appleAuth: authenticateUserWithApple(input: $input) {
      apiAccessToken {
        tokenString
        expiresAt
      }
      isNew
    }
  }
`
